import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { RoomI18n_DesignPage_Query } from "./query";

type Props = {
	hotelID: string;
	roomID: string;
	langCode: LangCode;
};

export const useRoomI18nArticleQuery = ({ hotelID, roomID, langCode }: Props) => {
	const { data } = useCustomSuspenseQuery(RoomI18n_DesignPage_Query, {
		variables: { hotelID, roomID, lang: langCode },
	});

	return {
		data,
	};
};
